import { getAssociatedTokenAddressSync } from "@solana/spl-token";
import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram, StakingAccount } from "../type";
import { deriveStakingAuthority } from "../pda";

export interface IWithdrawParams {
  referralProgram: ReferralProgram;
  unstakeAddress: PublicKey;
  escrowAddress: PublicKey;
  stakingAddress: PublicKey;
  stakingAccount: StakingAccount;
  owner: PublicKey;
  rentReceiver: PublicKey;
  receiver: PublicKey;
}

export async function createWithdrawIx(
  params: IWithdrawParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    unstakeAddress,
    escrowAddress,
    stakingAddress,
    stakingAccount,
    owner,
    rentReceiver,
    receiver,
  } = params;

  const ownerTokenVault = getAssociatedTokenAddressSync(
    stakingAccount.tokenMint,
    receiver,
    true,
  );

  return referralProgram.methods
    .withdraw()
    .accountsPartial({
      unstake: unstakeAddress,
      escrow: escrowAddress,
      staking: stakingAddress,
      tokenVault: stakingAccount.tokenVault,
      tokenMint: stakingAccount.tokenMint,
      ownerTokenVault,
      owner,
      rentReceiver,
      stakingAuthority: deriveStakingAuthority(referralProgram.programId),
    })
    .instruction();
}
